import { Tooltip, IconButton, Checkbox } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const columnsSolCompartilhamentoPonto = (handleDelete, handleCheck, editavel) => [
  {
    field: "id",
    headerName: "Seq.",
    flex: 1,
    renderCell: (params) => (
      <Tooltip title={params.value} placement="bottom">
        <p>{params.value}</p>
      </Tooltip>
    ),
  },
  {
    field: "Codigo",
    headerName: "Poste",
    flex: 1,
    renderCell: (params) => (
      <Tooltip title={params.value} placement="bottom">
        <p>{params.value}</p>
      </Tooltip>
    ),
  },
  {
    field: "Descricao",
    headerName: "Característica",
    flex: 3,
    renderCell: (params) => (
      <Tooltip title={params?.row?.Descricao} placement="bottom">
        <p>{params?.row?.Descricao}</p>
      </Tooltip>
    ),
  },
  {
    field: "Lat",
    headerName: "Latitude",
    flex: 2,
    renderCell: (params) => (
      <Tooltip title={params.value} placement="bottom">
        <p>{params.value}</p>
      </Tooltip>
    ),
  },
  {
    field: "Lng",
    headerName: "Longitude",
    flex: 2,
    renderCell: (params) => (
      <Tooltip title={params.value} placement="bottom">
        <p>{params.value}</p>
      </Tooltip>
    ),
  },
  {
    field: "TemOcupacao",
    headerName: "Tem ocupação",
    flex: 2,
    type: "boolean",
    renderCell: (params) => (
      <Tooltip title={params.value ? "Sim" : "Não"} placement="bottom">
        <Checkbox
          disabled={editavel}
          sx={{
            color: "#B8B8B8 !important",
            "&.Mui-checked": {
              color: "#4CAF50 !important",
            },
          }}
          checked={Boolean(params.value)}
          onChange={(e) => {
            e.stopPropagation();
            handleCheck(params.row);
          }}
          color="primary"
          inputProps={{ "aria-label": "Tem ocupação" }}
        />
      </Tooltip>
    ),
  },
  {
    field: "actions",
    headerName: "Ações",
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Tooltip title="Excluir" placement="bottom">
        <IconButton
          disabled={editavel}
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(params.row);
          }}
          color="error"
        >
          <FontAwesomeIcon icon={faTrash}  style={{ fontSize: "18px" }}/>
        </IconButton>
      </Tooltip>
    ),
  },
];

export { columnsSolCompartilhamentoPonto };
